import { Component, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { DfsService } from '../../services/dfs.service';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from '../../services/login.service';
import { Meter } from '../../models/meter.models';
import { OnboardMeterDialogComponent, OnboardMeterDialogData } from '../../components/onboard-meter-dialog/onboard-meter-dialog.component';
import { firstValueFrom } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-meter-details',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './meter-details.component.html',
  styleUrl: './meter-details.component.scss'
})
export class MeterDetailsComponent {

  // Meter Details
  meters: Meter[] = [];
  displayedMeterColumns: string[] = ['MeterNo', 'MeterType', 'Address', 'Organization'];
  dataSource = new MatTableDataSource<Meter>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  // Flags for UI state
  isLoading: boolean = true;
  errorMessage: string = '';
  isTPI: boolean = false;

  constructor(
    private dfsService: DfsService,
    private dialog: MatDialog,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.isTPI =  this.route.parent?.snapshot.data['tpiData']?.tpi || false;

    // Set columns based on TPI status
    this.setDisplayedColumns();

    this.fetchMeterInfo();
  }

  private setDisplayedColumns(): void {
    // Consent column retained in template but temporarily removed from displayed columns
    this.displayedMeterColumns = ['MeterNo', 'MeterType', 'Address', 'Organization'];
    
    if (this.isTPI) {
      this.displayedMeterColumns.push('Name', 'Email');
    }
  }

  ngAfterViewChecked(): void {
    if (!this.dataSource.paginator && this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
    if (!this.dataSource.sort && this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

  fetchMeterInfo(): void {
    this.dfsService.getMeterDetails().subscribe({
      next: (response: Meter[]) => {
        this.meters = response;
        this.dataSource.data = this.meters;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching meter info:', error);
        this.errorMessage = 'Failed to load meter information. Please try again later.';
        this.isLoading = false;
      }
    });
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    // Reset to the first page if the filter changes
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  addMeter() {
    this.dfsService.getLoggedInEmail().subscribe(email => {
        const dialogData: OnboardMeterDialogData = {
          email,
          isTpi: this.isTPI
        };

        const dialogRef = this.dialog.open(OnboardMeterDialogComponent, {
          width: '800px',
          maxWidth: '90vw',
          maxHeight: '90vh',
          data: dialogData,
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            // Meter was successfully onboarded, refresh the meter list
            this.fetchMeterInfo();
          }
        });
    });
  }
}
